import { Chip, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  badge: {
    fontSize: 11,
    height: 16,
    minWidth: 16,
    margin: 6,
    borderRadius: 8,
    zIndex: "inherit",
  },
  chipRoot: {
    fontSize: 11,
    margin: 2,
    height: 28,
    borderRadius: 5,
    backgroundColor: theme.lightPrimaryColor,
    color: theme.palette.primary.main,
    "&:focus": {
      backgroundColor: theme.lightPrimaryColor,
    },
  },
  chipDeleteIcon: {
    cursor: "pointer",
    paddingRight: 12,
  },
  shipmentListContainer: {
    padding: "8px 0px",
  },
});

const StopChipList = (props) => {
  const { classes, customerStops, isPickupStopMergeFlow=false } = props;
  return (
    <div className={classes.shipmentListContainer}>
      {customerStops.map((customerStop) => (
        <Chip
          label={isPickupStopMergeFlow ? customerStop.shipperName: customerStop.consigneeName}
          key={customerStop.key}
          classes={{
            root: classes.chipRoot,
            icon: classes.chipDeleteIcon,
            label: classes.chipLabel,
          }}
          clickable={false}
          color="primary"
        />
      ))}
    </div>
  );
};
export default withStyles(styles)(StopChipList);
